export type VideoConstraints = {
	maxDuration?: number;
	minFPS?: number;
	maxFPS?: number;
};

const useVideoGenerationError = () => {
	const getVideoConstraints = (tool?: string): VideoConstraints => {
		switch (tool) {
			case "erase":
				return { maxDuration: 5, minFPS: 20, maxFPS: 30 };
			case "remove_background":
				return { maxDuration: 60 };
			case "solid_background":
				return { maxDuration: 60 };
			case "increase_resolution":
				return { maxDuration: 30 };
			default:
				return {};
		}
	};

	const mapVideoGenerationError = (errorMessage: string): string => {
		switch (errorMessage) {
			case "No objects detected for prompt":
				return "Object not detected. Please refine your prompt with more specific details, such as color or location (e.g., 'Red umbrella', 'Black phone', 'Glasses on woman with blonde hair')";
			case "Multiple objects detected for prompt":
				return "Ambiguous detection: Multiple objects found. Please refine your prompt to target a single object";
			default:
				return errorMessage;
		}
	};

	return {
		getVideoConstraints,
		mapVideoGenerationError,
	};
};

export default useVideoGenerationError;
